import { ref,toRaw, isRef, registerRuntimeCompiler, nextTick } from 'vue'
import { ElMessage } from 'element-plus'


function isDescendantById(parent, targetId) {
    if (!parent?.children) return false
    for (const child of parent.children) {
        if (child.id === targetId || isDescendantById(child, targetId)) return true
    }
    return false
}

export function useDragAndDrop({
            nodes,
            activeRoot,
            elements,
            buildHierarchy,
            elementData,
            elementDataMap,
            oneLevelMode = false,
            onMoveNode = async () => {},
            onMoveElement = async () => {},
            onRestoreElement = async () => {},
            selectNodeAndElement = async () => {},
            checkElementUniqueName = () => {},
            onValidateElement = async () => {},
            disableElementMove = false,
            disableNodeMove = false,
            deny = ()=>{},
            resource,
            elementOrdnungMode = false
       }) {
    const dragData = ref(null)
    const nodesRef = isRef(nodes) ? nodes : ref(nodes)
    const elementList = isRef(elements) ? elements : ref(elements)


    const expandAncestorsOnNodesRef = (id) => {
        const map = new Map((nodesRef.value || []).map(n => [n.id, n]))
        let curr = map.get(id)
        while (curr && curr.parent_id != null) {
            const p = map.get(curr.parent_id)
            if (!p) break
            p.expanded = true
            curr = p
        }
        const tgt = map.get(id)
        if (tgt) tgt.expanded = true
    }

    function startDragNode(node) {
        //if(resource && !user.can({res:resource+"-group", act:"move"})) return
        if(deny('group','move')) return
        if (disableNodeMove) return
        dragData.value = { type: 'node', node }
    }

    function startDragElement(element) {
        //if(resource && !user.can({res:resource+"-element", act:"move"})) return
        if(deny('element','move')) return
        if (disableElementMove && !elementOrdnungMode) return
        if (elementOrdnungMode && element?.ordnung === undefined) return
        dragData.value = { type: 'element', element }
    }

    async function dropOnNode(targetNode, dropPosition = 'after') {

//if(targetNode.fixed)return null

        if (!dragData.value) return null
        const current = dragData.value
        dragData.value = null

        if (current.type === 'node') {

            const node = current.node
            if (disableNodeMove) return null
            if (node.fixed === true) return null
            if (!nodesRef.value?.length) return null
            if (targetNode.id === node.id) return null
            if (!oneLevelMode && isDescendantById(node, targetNode.id)) return null
            try {
                if (oneLevelMode && typeof node.ordnung === 'number') {
                    const list = nodesRef.value
                    const fromIdx = list.findIndex(n => n.id === node.id)
                    const toIdx   = list.findIndex(n => n.id === targetNode.id)
                    if (fromIdx === -1 || toIdx === -1 || fromIdx === toIdx) return null
                    const insertBefore = dropPosition === 'before'
                    const [moved] = list.splice(fromIdx, 1)
                    let finalInsertIdx = insertBefore ? toIdx : toIdx + 1
                    if (fromIdx < finalInsertIdx) finalInsertIdx--
                    list.splice(finalInsertIdx, 0, moved)
                    list.forEach((n, i) => {
                        if (typeof n.ordnung === 'number') n.ordnung = i
                    })
                    buildHierarchy(list, activeRoot, { oneLevelMode })
                    const movePayload = { ordnung: finalInsertIdx }
                    if (Object.prototype.hasOwnProperty.call(node, 'parent_id')) {
                        movePayload.parent_id = node.parent_id ?? null
                    }
                    if (!(await onMoveNode(node.id, movePayload))) {
                        throw new Error('Node move rejected by server')
                    }
                    return current

                } else if (oneLevelMode) {
                    return null

                } else {
                    const idx = nodesRef.value.findIndex(n => n.id === node.id)
                    if (idx === -1) return null
                    const prevParent = nodesRef.value[idx].parent_id
                    nodesRef.value[idx].parent_id = targetNode.id
                    expandAncestorsOnNodesRef(targetNode.id)
                    //buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: false })
                    if (!(await onMoveNode(node.id, { parent_id: targetNode.id }))) {
                        nodesRef.value[idx].parent_id = prevParent
                        return null
                        //throw new Error('Node move rejected by server')
                    }
                    buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: false })
                    return current
                }
            } catch (err) {
                console.error('Помилка переміщення вузла:', err)
                ElMessage.error('Не вдалося перемістити групу. Зміни скасовано.')
                return null
            }
        }

        if (current.type === 'element') {
            if (disableElementMove) {
                return current
            }
            const element = current.element
            if (element.fixed === true) return current

            if(!checkElementUniqueName(targetNode.id, element) || !(await onValidateElement(targetNode.id)))return current

            try {
                if (element.hide) {
                    const restored = await onRestoreElement(element, targetNode.id)
                    if (restored) {
                        expandAncestorsOnNodesRef(targetNode.id)
                        buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode })
                        selectNodeAndElement(targetNode.id, element.id)
                    }
                } else if (targetNode.id !== element.grp_id)
                {
                    const prevElementData = (elementData?.id === element.id)
                        ? { grp_id: elementData.grp_id, hide: elementData.hide, ordnung: elementData.ordnung }
                        : null
                    const prevMapEntry = elementDataMap.get(element.id)
                        ? structuredClone(toRaw(elementDataMap.get(element.id)))
                        : null
                    const listIdx = elementList.value.findIndex(u => u.id === element.id)
                    const prevListEntry = listIdx !== -1
                        ? structuredClone(toRaw(elementList.value[listIdx]))
                        : null

                    const nextOrdnung = 0

                    if (elementData?.id === element.id) {
                        elementData.grp_id = targetNode.id
                        elementData.hide = false
                        elementData.ordnung = nextOrdnung
                    }
                    const mappedElement = elementDataMap.get(element.id)
                    if (mappedElement) {
                        mappedElement.grp_id = targetNode.id
                        mappedElement.hide = false
                        mappedElement.ordnung = nextOrdnung
                    }
                    if (listIdx !== -1) {
                        elementList.value[listIdx].grp_id = targetNode.id
                        elementList.value[listIdx].hide = false
                        elementList.value[listIdx].ordnung = nextOrdnung
                    }
                    expandAncestorsOnNodesRef(targetNode.id)
                    buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode })
                    selectNodeAndElement(targetNode.id, element.id)

                    const movePayload = { id: element.id, grp_id: targetNode.id, ordnung: nextOrdnung }
                    const moved = await onMoveElement(movePayload)
                    if (!moved) {
                        if (prevElementData && elementData?.id === element.id) {
                            elementData.grp_id = prevElementData.grp_id
                            elementData.hide = prevElementData.hide
                            elementData.ordnung = prevElementData.ordnung
                        }
                        if (prevMapEntry) elementDataMap.set(element.id, prevMapEntry)
                        if (listIdx !== -1 && prevListEntry) {
                            elementList.value[listIdx] = prevListEntry
                        }
                        buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode })
                        throw new Error('Element move rejected by server')
                    }
                }
            } catch (err) {
                console.error('Помилка переміщення елемента:', err)
                ElMessage.error('Не вдалося перемістити елемент. Помилка на сервері.')
            }

            return current
        }

        return current
    }

    return {
        dragData,
        startDragNode,
        startDragElement,
        dropOnNode
    }
}
